import { OverlayTrigger, Tooltip } from 'react-bootstrap'
const CHARITY_ICON = '/static/images/icons/charity-storage-7-abc-30.png'
const NONLIEN_ICON = '/static/images/icons/Badge_NonLien.svg'

function AuctionBadge({ auction, ...props }) {
    let badgeIcon = null
    let badgeText = null
    let badgeToolTip = null
    let tooltip = null
    let badgeIconAdjust = ''

    switch (auction.type_id) {
        case '1':
            badgeToolTip = (
                <Tooltip id="badge-tooltip">
                    A storage facility will post a lien unit to legally recover rent and fees owed by a self storage tenant that has abandoned their unit.
                </Tooltip>
            )
            badgeIcon = NONLIEN_ICON
            badgeText = 'LIEN UNIT'
            break
        case '2': // Non-Lien Unit / Manager Special
            badgeToolTip = (
                <Tooltip id="badge-tooltip">
                    A storage facility will post a non-lien unit when items are left behind by tenants vacating their unit.
                </Tooltip>
            )
            badgeIcon = NONLIEN_ICON
            badgeText = 'NON-LIEN UNIT/MANAGER SPECIAL'
            break
        case '3': // Charity Unit
            badgeToolTip = (
                <Tooltip id="badge-tooltip">
                    The contents of this unit were donated and the proceeds of this sale will be distributed to
                    various charities. More information can be found on CharityStorage.org. Please review the
                    Charity Unit Auction Rules below. 100% of the Sale Price and Buyer Premium will be charged to the credit card
                    on file.
                </Tooltip>
            )
            badgeIcon = CHARITY_ICON
            badgeText = 'CHARITY UNIT'
            badgeIconAdjust = ' charity'
            break
        case '4': // Private Seller
            badgeToolTip = (
                <Tooltip id="badge-tooltip">
                    Private Sellers are not affiliated with a storage facility and sell items from a storage unit they are leasing.
                    These units are auctioned as a single lot, and upon winning, you will arrange payment with the Private Seller.
                </Tooltip>
            )
            badgeIcon = NONLIEN_ICON
            badgeText = 'NON-LIEN UNIT/PRIVATE SELLER'
            break
    }

    if (!badgeText) {
        return null
    }

    if (badgeToolTip) {
        tooltip = (
            <OverlayTrigger placement="bottom" overlay={badgeToolTip}>
                <span className="badge-help" {...props}>
                    <i className="fa fa-2x fa-question-circle" aria-hidden="true"/>
                </span>
            </OverlayTrigger>
        )
    }

    return (
        <div className="col-md-12 marginB15">
            <div className="buyer-badge-container">
                <div className="buyer-badge">
                    <img src={badgeIcon} alt="Auction Badge" className={`badge-icon${badgeIconAdjust}`}/>
                    <div className="badge-text">
                        {badgeText}
                    </div>
                </div>
                {tooltip}
            </div>
        </div>
    )
}

export default AuctionBadge
